import React from 'react';
import { Typography } from '@mui/material';

function Academics() {

    return (
        <div>
            <Typography sx={{ color: "white", margin: "10px 30px 0 30px" }} variant="h4">
                Academics
            </Typography>
            <Typography sx={{ color: "white", margin: "10px 30px 10px 30px" }} variant="h6">
                The best ways to get in touch.
            </Typography>
        </div>
    )
}

export default Academics